import { createHookContext } from '@clover-util/react-context';
import { useScript } from '@clover-util/script-registry';
import { useEffect, useMemo, useState } from 'react';
import { getPakmsKey, getScriptUrl } from 'routes/Checkout/util';
import { useMerchant } from 'hooks/context/merchant';

const ENV = process.env.NODE_ENV;
export const PAKMS = getPakmsKey(ENV);

export const [useCloverPaymentIframeContext, CloverPaymentIframeProvider] = createHookContext('CloverPaymentIframe', () => {
  const [cloverInstance, setCloverInstance] = useState<Clover>();

  const cloverElementsInstance = useMemo(() => cloverInstance?.elements(), [cloverInstance]);

  const [scriptLoaded, scriptError] = useScript(getScriptUrl(ENV));

  const { merchant } = useMerchant();

  useEffect(() => {
    if (!scriptLoaded || !merchant) return;

    setCloverInstance(instance => instance ?? new Clover(
      PAKMS,
      { merchantId: merchant?.merchantUuid }
    ));
  }, [scriptLoaded, merchant]);

  return {
    cloverInstance,
    cloverElementsInstance,
    isScriptLoading: !scriptLoaded,
    scriptHasError: !!scriptError
  };
});

export type CloverPaymentIframeContextType = ReturnType<typeof useCloverPaymentIframeContext>
